export default __webpack_public_path__ + "static/media/swappirate.c8f67db6.png";